import React from "react";
import styles from "./styles.module.scss";
import { useClientQuery } from "../../../../../../../../../api/queries/useClientQuery";

/**
 * @param {{ patientId: number }} param0
 */
export const Header = ({ patientId }) => {
  const { data: patient } = useClientQuery({
    clientId: patientId,
  });

  return (
    <div className={styles.root}>
      <div className={styles.name}>{patient?.fullName}</div>
      <div className={styles.phone}>{patient?.phone}</div>
    </div>
  );
};
